import component from './overviewContainer.vue'

export default component
